import React from 'react';
import './IntroGuideOverlay.css';
import { useTranslation } from 'react-i18next';
import { FaMapMarkedAlt, FaLightbulb, FaFastForward } from 'react-icons/fa';

const IntroGuideOverlay = ({ onClose, hasSkip }) => {
    const { t } = useTranslation();

    return (
        <div className="intro-guide-overlay">
            <div className="intro-guide-content">
                <h2 className="intro-guide-title">{t('intro_welcome')}</h2>
                
                <div className="intro-features-list">
                    <div className="intro-feature-item">
                        <div className="intro-feature-icon hint-icon">
                            <FaLightbulb />
                        </div>
                        <div className="intro-feature-text">
                            <p>{t('intro_hint_desc')}</p>
                        </div>
                    </div>

                    <div className="intro-feature-item">
                        <div className="intro-feature-icon map-icon">
                            <FaMapMarkedAlt />
                        </div>
                        <div className="intro-feature-text">
                            <p>{t('intro_map_desc')}</p>
                        </div>
                    </div>

                    {hasSkip && (
                        <div className="intro-feature-item">
                            <div className="intro-feature-icon skip-icon">
                                <FaFastForward />
                            </div>
                            <div className="intro-feature-text">
                                <p>{t('intro_skip_desc')}</p>
                            </div>
                        </div>
                    )}
                </div>

                <div className="intro-bg-hint-box">
                    {t('intro_bg_hint')}
                </div>

                <button className="intro-start-button" onClick={onClose}>
                    {t('intro_start_button')}
                </button>
            </div>
        </div>
    );
};

export default IntroGuideOverlay;
